export interface ClientTraceEvent { name:'client.request'; at:number; durationMs:number; method:string; path:string; status:number|null; ok:boolean; recording:string }
const key='stats.trace-client-events';
export function recordClientRequest(event:ClientTraceEvent) {
  try {
    const events=JSON.parse(sessionStorage.getItem(key)??'[]') as ClientTraceEvent[];
    events.push(event);sessionStorage.setItem(key,JSON.stringify(events.slice(-2000)));
  }catch{/* Diagnostics must not affect the API request. */}
}
export function clientTraceEvents(recording:string):ClientTraceEvent[] {
  try{return (JSON.parse(sessionStorage.getItem(key)??'[]') as ClientTraceEvent[]).filter(e=>e.recording===recording);}catch{return [];}
}
